<template>
  <div>{{ nowDate }}</div>
</template>

<script>
export default {
  data() {
    return {
      nowDate: "", // 当前日期
    };
  },
  methods: {
    currentTime() {
      setInterval(this.formatDate, 500);
    },
    formatDate() {
      // let date = new Date();
      let date = new Date();
      let ydate = date.toString().split(' ').slice(0, 4).join(' ')
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      if (this.$store.state.num == 2) {
        let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        this.nowDate = `${year}年${month}月${day}日 ${weekArr[week]}`;
      } else {
        // let weekArr = ["Sun.", "Mon.", "Tues.", "Wed.", "Thu.", "Fri.", "Sat."];
        this.nowDate = ydate;
      }

    }
  },
  mounted() {
    this.currentTime();
  },
  // 销毁定时器
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
    }
  }
};
</script>